import { ChangeDetectionStrategy, Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ApproveDialogData } from '@shared/models/approve-dialog.model';
import { ModelForm } from '@shared/models';
import { ZDialogComponent } from '../z-dialog/z-dialog.component';
import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material/button-toggle';
import { MatIcon } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { ZFormGridComponent } from '../z-form-grid/z-form-grid.component';
import { ZInputComponent } from '../z-input/z-input.component';
import { ZButtonComponent } from '../z-button/z-button.component';
import { TranslatePipe } from '@ngx-translate/core';

interface ApproveForm {
  [key: string]: any;
}

@Component({
    selector: 'app-approve-dialog',
    templateUrl: './approve-dialog.component.html',
    styleUrls: ['./approve-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ZDialogComponent,
        ReactiveFormsModule,
        MatButtonToggleGroup,
        MatButtonToggle,
        MatIcon,
        NgIf,
        ZFormGridComponent,
        ZInputComponent,
        ZButtonComponent,
        TranslatePipe,
    ],
})
export class ApproveDialogComponent implements OnDestroy {
  private sub = new Subscription();

  form: FormGroup<ModelForm<ApproveForm>> = new FormGroup<ModelForm<ApproveForm>>({
    decision: new FormControl(null, Validators.required),
    observations: new FormControl(null),
  });

  constructor(
    public dialogRef: MatDialogRef<ApproveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ApproveDialogData,
  ) {
    // Se quiser tornar observações obrigatórias quando rejeitado:
    // this.sub.add(
    //   this.form.get('decision')!.valueChanges.subscribe((v) => {
    //     const obs = this.form.get('observacoes') as FormControl;
    //     if (v === 'rejected') {
    //       obs.setValidators([Validators.required, Validators.maxLength(2000)]);
    //     } else {
    //       obs.clearValidators();
    //     }
    //     obs.updateValueAndValidity();
    //   })
    // );
  }

  ngOnInit(): void {
    this.form.reset();
    const { fields } = this.data;
    if (fields?.length) {
      fields.forEach((field) => {
        const controlName = field.formControlName;
        if (!controlName) {
          return;
        }

        this.form.addControl(
          controlName,
          new FormControl(
            field.value !== undefined ? field.value : null,
            field.required ? [Validators.required] : [],
          ),
        );
      });
      this.form.updateValueAndValidity();
    }
  }

  confirm() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const payload = {
      // Inclui os valores de todos os campos (inclui os `fields` dinâmicos, ex.: anexo).
      ...this.form.getRawValue(),
      decision: this.form.controls['decision'].value,
      approved: this.form.controls['decision'].value === 'approved',
      observacoes: this.form.controls['observations'].value,
      valorNota: this.form.controls['valorNota']?.value,
    };

    this.dialogRef.close(payload);
  }

  cancel() {
    this.dialogRef.close(null);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
